/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/activityManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '营销管理',
      icon: 'component',
    },
    children: [
      {
        path: '/activityManage/selectActivityType',
        component: () => import('@/myviews/shoppMall/activityManage/seckillActivity/selectActivityType.vue'),
        alwaysShow: false,
        name: 'SelectActivityType',
        meta: {
          alwaysShow: false,
          title: '活动专区',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/specialProductConfig',
        component: () => import('@/myviews/shoppMall/activityManage/specialProductConfig/index.vue'),
        alwaysShow: false,
        name: 'SpecialProductConfig',
        meta: {
          title: '专项商品配置',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/specialConfig',
        component: () => import('@/myviews/shoppMall/activityManage/specialProductConfig/specialConfig.vue'),
        name: 'specialConfig',
        hidden: true,
        meta: {
          alwaysShow: false,
          title: '专项商品推荐配置',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/firstActivity',
        component: () => import('@/myviews/shoppMall/activityManage/firstActivity/firstActivity.vue'),
        name: 'firstActivity',
        hidden: true,
        meta: {
          title: '用户首次',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/seckillActivity',
        component: () => import('@/myviews/shoppMall/activityManage/seckillActivity/index.vue'),
        name: 'SeckillActivity',
        hidden: true,
        meta: {
          title: '活动列表',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/operateActivity',
        component: () => import('@/myviews/shoppMall/activityManage/operateActivity/index.vue'),
        alwaysShow: false,
        name: 'OperateActivity',
        meta: {
          title: '礼包活动',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/addOperateActivity',
        component: () => import('@/myviews/shoppMall/activityManage/operateActivity/addOperateActivity.vue'),
        name: 'AddOperateActivity',
        hidden: true,
        meta: {
          alwaysShow: false,
          title: '礼包活动详情',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/operateReceiveDetail',
        component: () => import('@/myviews/shoppMall/activityManage/operateActivity/operateReceiveDetail.vue'),
        alwaysShow: false,
        name: 'OperateReceiveDetail',
        meta: {
          title: '礼包领取详情',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activityManage/userBlacklist',
        component: () => import('@/myviews/shoppMall/activityManage/userBlacklist/index.vue'),
        alwaysShow: false,
        name: 'BserBlacklist',
        meta: {
          title: '用户黑名单',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/activityManage.js